"use client";

import BreadCrumb from "@/shared/components/common/breadCrumb/BreadCrumb";
import Flex from "@/shared/components/common/Flex";
import ImageGallery from "@/shared/components/common/Image-Gallery/Image-Gallery";
import type { HotelDetail } from "@/types/services/hotel/apis/Detail";

interface TopBarProps {
  hotelName: string;
  hotelImages: HotelDetail["images"];
  cityName: string;
  city: string;
}

export default function TopBar({
  hotelName,
  hotelImages,
  cityName,
  city,
}: TopBarProps) {
  const filteredImages = hotelImages.filter(({ type }) => type === "large");

  return (
    <Flex className="flex-col pt-4 md:py-4 gap-y-4 px-2" id="about">
      <BreadCrumb
        page="detail"
        city={cityName}
        hotel={{ persian: hotelName, code: city }}
      />
      <ImageGallery images={filteredImages.map(({ path }) => path)} />
    </Flex>
  );
}
